// @flow
import modularui from "../_modularui/ModularUIConnector";

import type { ModularUIConnector } from "../_modularui/types";

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useContentTOC' instead
 */
export const connectContentDetail: ModularUIConnector = modularui(
  "ContentDetail",
  ({ content, location }) =>
    `/content/${decodeURIComponent(content)}${location.search}`,
  { propName: "contentTOC" },
);
